<template>
  <div>
    <page-header
      :actions="headerActionsConfig"
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
    />
    <div class="mx-3 my-2">
      <contract-request-compensatory
        ref="requestCompensatory"
        :collapsable="false"
        :has-actions="false"
        :is-read-only="readOnly"
        :item="request"
        @on-save="onLoadRequest"
      />
    </div>
  </div>
</template>

<script>
//libs components
import PageHeader from 'PageHeader';
import { getByParameterName } from '@/services/common/sysparameter.api';
import { getClosingAnalysisByIdRequest as _getClosingAnalysisByIdRequest } from '@/services/provider/closing-analysis.api';
import ContractRequestCompensatory from '@/views/uspqrp/contract-management/components/tabs/ContractRequestCompensatory.vue';
//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';

//constants
import storeModuleNames from '@/utils/constants/storeModuleNames.js';
import compensatoryRequestStatus from '@/utils/constants/compensatoryRequestStatus';
import viewDisplay from '@/utils/constants/compensatoryRequestView';

export default {
  name: 'RequestClosingAnalysis',
  mixins: [storeMixin, alertMixin],
  components: {
    PageHeader,
    ContractRequestCompensatory,
  },
  data: () => ({
    moduleName: storeModuleNames.UspqrpContractModuleName,
    filterModel: {
      academicYear: null,
      provider: null,
      specialist: null,
      contractType: null,
      disciplineType: null,
      contractStatus: null,
      sieOrRegistryNumber: null,
      studentName: null,
      requestNumber: null,
      contractNumber: null,
      isSortByStudentNameAsc: true,
    },
    filterOptions: {
      academicYears: [],
      providers: [],
      specialists: [],
      contractTypes: [],
      disciplineTypes: [],
      contactStatuses: [],
    },
    results: [],
    requireAcademicYear: null,
    aeeFeaturesEnabled: false,
    request: {},
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Análisis de Cierre',
        icon: 'fas fa-clipboard-list',
        routes: ['Inicio', 'USPQRP', 'Contrato', 'Análisis de Cierre'],
      };
    },
    headerActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left fa-fw',
          variant: 'outline-success',
          click: () => this.onGoBackHandler(),
        },
        {
          text: 'Someter',
          icon: 'fas fa-flag',
          variant: 'outline-success',
          visible: !this.readOnly,
          click: () => this.$refs.requestCompensatory.submitHandler(),
        },
      ];
    },
    viewDisplayEnum() {
      return viewDisplay;
    },
    readOnly() {
      return !this.analysisApply.includes(this.request.statusId);
    },
    requestStatus() {
      return compensatoryRequestStatus;
    },
    analysisApply() {
      return [
        this.requestStatus.Aprobado,
        this.requestStatus.DevueltoAProveedor,
      ];
    },
  },
  async mounted() {
    await this.onLoadRequest();
  },
  methods: {
    async getClosingAnalysisByIdRequest(requestId) {
      const { data } = await _getClosingAnalysisByIdRequest(requestId);

      this.request = {
        ...data,
        academicYear: data.academicYearDescription,
        requestId: data.compensatoryRequestId,
        requestNumber: data.requestNumber,
        comment: data.description,
        statusId: data.statusId,
        status: data.statusName,
        statusColor: data.statusColor,
        dueInterventions: data.owedInterventions,
        origin: data.origin,
        offeredInterventions: data.sessionOffers,
        currentBalance: data.currentBalance,
        isOpen: true,
        viewToDisplay: this.viewDisplayEnum.CLOSING_ANALYSIS,
      };
    },
    async getAEESysParameter() {
      const { data } = await getByParameterName(
        'RPExtendedSchoolYearFeatureFlag'
      );
      if (data) {
        this.aeeFeaturesEnabled = data.value === 'true';
      }
    },
    async onLoadRequest() {
      await this.getClosingAnalysisByIdRequest(this.$route.params.requestId);
    },
    onGoBackHandler() {
      this.$router.go(-1);
    },
  },
};
</script>
